import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CatalogFilterState {
  species: {
    [genus: string]: {
      selected: boolean;
      species: {
        [speciesName: string]: boolean;
      };
    };
  };
  imageTypes: {
    mosquito: boolean;
    mesh: boolean;
    emptyMesh: boolean;
    bycatch: boolean;
    debris: boolean;
    bookmarked: boolean;
  };
  trapsites: string[];
  devices: string[];
  capturedAfter: string | null;
  capturedBefore: string | null;
  page: number;
}

const initialState: CatalogFilterState = {
  species: {},
  imageTypes: {
    mosquito: true,
    mesh: true,
    emptyMesh: false,
    debris: false,
    bycatch: true,
    bookmarked: false,
  },
  trapsites: [],
  devices: [],
  capturedAfter: null,
  capturedBefore: null,
  page: 0,
};

const catalogFilterSlice = createSlice({
  name: "catalogFilter",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<CatalogFilterState>>) => {
      const { page, imageTypes, ...otherFilters } = action.payload;

      let isFilterChanged = false;

      if (imageTypes) {
        state.imageTypes = { ...state.imageTypes, ...imageTypes };
        isFilterChanged = true;
      }

      if (Object.keys(otherFilters).length > 0) {
        Object.assign(state, otherFilters);
        isFilterChanged = true;
      }

      // If page is explicitly provided, use it.
      // Otherwise, if any filter is changed, reset page to 0.
      if (page !== undefined) {
        state.page = page;
      } else if (isFilterChanged) {
        state.page = 0;
      }
    },
    resetCatalogFilters: () => initialState,
  },
});

export const { setFilters, resetCatalogFilters } = catalogFilterSlice.actions;

export default catalogFilterSlice.reducer;
